import { ProgressTrackerState } from "@/types";
import { createSlice } from "@reduxjs/toolkit";
import { initProgressTracker } from "./progressTrackerThunks";

// Initial state
const initialState: ProgressTrackerState = {
  totalUsersData: {},
  activeUsersData: {},
  questionsAttemptedData: {},
  totalQuestionsAttemptedData: {},
  questionsUploaded: {},
  loading: false,
  error: '',
  initialized: false
}

const progressTrackerSlice = createSlice({
  name: "init",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initProgressTracker.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(initProgressTracker.fulfilled, (state, action) => {
        state.loading = false
        state.totalUsersData = action.payload.totalUsersData
        state.activeUsersData = action.payload.activeUsersData
        state.questionsAttemptedData = action.payload.questionsAttemptedData
        state.totalQuestionsAttemptedData = action.payload.totalQuestionsAttemptedData
        state.questionsUploaded = action.payload.questionsUploaded
        state.initialized = true;
      })
      .addCase(initProgressTracker.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.initialized = false
      })
  },
});

export default progressTrackerSlice.reducer
